import { Injectable } from '@angular/core';
import { AnnotationDefaults } from '../app/models/configuration/draw/annotation-defaults.model';
import {ToothConfigurationModel} from './models/teeth/tooth-configuration.model';
import {dataPatient, dataPatientCaseWorkItem} from './modules/ar/_models/ar.models';
import {PatientDataModel} from './models/patient/patient-data.model';
import {PatientCaseViewDataModel} from './models/patient/patient-case-view-data.model';
import {ARLedgerTableColumn} from './modules/ar/models/ar-ledger-table.model';
import {
    IReferralAppointment,
    IRescheduleAppointment
} from './modules/configuration/referral-configuration/models/referral-data.model';
@Injectable()
export class Globals {
    static imageViewer: lt.Controls.ImageViewer;
    static annotationsDefaults: AnnotationDefaults;
    static imageProcessingInstance: lt.ImageProcessing = null;

    tdo12patientNO: string = '';
    currentToothNumberingId: string = '00000028-1000-0000-0000-000000000001';

    // referral values(referral management module)
    validTDOXpatientID: string;

    private intervalTimer: any = false;
    teeth: ToothConfigurationModel[] = [];

    // Patient ////////////////////////////////////////////////////////////////////////////
    /// ////////////////////////////////////////////////////////////////////////////////////
    ThePatient: PatientDataModel;

    get currentPatientId(): string {
        return localStorage.getItem('currentPatientId');
    }

    set currentPatientId(value: string) {
        console.log('SET currentPatientId: ', value);
        localStorage.setItem('currentPatientId', value);
    }

    get currentPatientFullName(): string {
        return localStorage.getItem('currentPatientFullName');
    }

    set currentPatientFullName(value: string) {
        localStorage.setItem('currentPatientFullName', value);
    }

    get currentPatientCaseId(): string {
        return localStorage.getItem('currentPatientCaseId');
    }

    set currentParentPatientCaseId(value: string) {
        localStorage.setItem('currentParentPatientCaseId', value);
    }

    get currentParentPatientCaseId(): string {
        return localStorage.getItem('currentParentPatientCaseId');
    }

    set currentPatientCaseId(value: string) {
        localStorage.setItem('currentPatientCaseId', value);
    }

    get currentPatientCaseWorkItem(): dataPatientCaseWorkItem {
        return JSON.parse(localStorage.getItem('currentPatientCaseWorkItem')) as dataPatientCaseWorkItem;
    }

    set currentPatientCaseWorkItem(value: dataPatientCaseWorkItem) {
        localStorage.setItem('currentPatientCaseWorkItem', JSON.stringify(value));
    }

    get currentPatientCaseWorkItemID(): string {
        return localStorage.getItem('currentPatientCaseWorkItemID');
    }

    set currentPatientCaseWorkItemID(value: string) {
        localStorage.setItem('currentPatientCaseWorkItemID', value);
    }

    get currentPatientCaseWorkItemEventID(): string {
        return localStorage.getItem('currentPatientCaseWorkItemEventID');
    }

    set currentPatientCaseWorkItemEventID(value: string) {
        localStorage.setItem('currentPatientCaseWorkItemEventID', value);
    }

    get currentPatientCaseWorkItemFormsID(): string {
        return localStorage.getItem('currentPatientCaseWorkItemFormsID');
    }

    set currentPatientCaseWorkItemFormsID(value: string) {
        localStorage.setItem('currentPatientCaseWorkItemFormsID', value);
    }

    get currentPatientSelectedCaseItem(): any {
        const patientCase = localStorage.getItem('currentPatientSelectedCaseItem');
        if (patientCase && patientCase !== undefined && patientCase !== 'undefined') {
            return JSON.parse(patientCase) as PatientCaseViewDataModel;
        } else {
            return '';
        }
    }

    set currentPatientSelectedCaseItem(value: any) {
        localStorage.setItem('currentPatientSelectedCaseItem', JSON.stringify(value));
    }
    // End Patient /////////////////////////////////////////////////////////////////////////

    //
    get LOCID(): string {
        return localStorage.getItem('LOCID');
    }

    set LOCID(value: string) {
        localStorage.setItem('LOCID', value);
    }

    get LOCenumCountryId(): string {
        return localStorage.getItem('LOCenumCountryId');
    }

    set LOCenumCountryId(value: string) {
        localStorage.setItem('LOCenumCountryId', value);
    }

    get showSuburbInAddress(): boolean {
    // TRUE FALSE
        let ret: boolean = false;
        const s = localStorage.getItem('showSuburbInAddress');
        if (s == 'TRUE')
        {ret = true; }

        return ret ;
    }

    set showSuburbInAddress(value: boolean ) {
    // TRUE FALSE
        let s: string = 'FALSE';
        if (value)
        {s = 'TRUE'; }
        localStorage.setItem('showSuburbInAddress', s);
    }




    get TDOCID(): string {
        return localStorage.getItem('TDOCID');
    }

    set TDOCID(value: string) {
        localStorage.setItem('TDOCID', value);
    }

    get WorkStationName(): string {
        return localStorage.getItem('WorkStationName');
    }

    set WorkStationName(value: string) {
        localStorage.setItem('WorkStationName', value);
    }

    get WorkStationID(): string {
        return localStorage.getItem('WorkStationID');
    }

    set WorkStationID(value: string) {
        localStorage.setItem('WorkStationID', value);
    }

    get currentAppointmentId(): string {
        return localStorage.getItem('currentAppointmentId');
    }

    set currentAppointmentId(value: string) {
        localStorage.setItem('currentAppointmentId', value);
    }

    get appointmentData(): string {
        return localStorage.getItem('appointmentData');
    }

    set appointmentData(value: string) {
        localStorage.setItem('appointmentData', value);
    }
    // Provider
    /// ////////////////////////////////////////////////////////
    get currentProviderDoctorUserID(): string {
        return localStorage.getItem('currentProviderDoctorUserID');
    }

    set currentProviderDoctorUserID(value: string) {
        localStorage.setItem('currentProviderDoctorUserID', value);
    }

    get currentProviderDoctorID(): string {
        return localStorage.getItem('currentProviderDoctorID');
    }

    set currentProviderDoctorID(value: string) {
        localStorage.setItem('currentProviderDoctorID', value);
    }

    get currentProviderDoctorContactID(): string {
        return localStorage.getItem('currentProviderDoctorContactID');
    }

    set currentProviderDoctorContactID(value: string) {
        localStorage.setItem('currentProviderDoctorContactID', value);
    }
    get currentProviderDoctorFullName(): string {
        return localStorage.getItem('currentProviderDoctorFullName');
    }

    set currentProviderDoctorFullName(value: string) {
        localStorage.setItem('currentProviderDoctorFullName', value);
    }

    // AR
    /// /////////////////////////////////////////////////////////////

    // ledger table layout and filters
    get currentLedgerTableLayout(): any[] {
        if (localStorage.getItem('currentLedgerTableLayout')) {
            return JSON.parse(localStorage.getItem('currentLedgerTableLayout')) as any[];
        } else {
            return [];
        }
    }
    set currentLedgerTableLayout(value: any[]) {
        localStorage.setItem('currentLedgerTableLayout', JSON.stringify(value));
    }

    get ledgerActiveFilterVoidOn(): string {
        return localStorage.getItem('ledgerActiveFilterVoidOn');
    }
    set ledgerActiveFilterVoidOn(value: string) {
        localStorage.setItem('ledgerActiveFilterVoidOn', value);
    }

    get ledgerActiveFilterDoctorOn(): string {
        return localStorage.getItem('ledgerActiveFilterDoctorOn');
    }
    set ledgerActiveFilterDoctorOn(value: string) {
        localStorage.setItem('ledgerActiveFilterDoctorOn', value);
    }

    get ledgerActiveFilterLocationOn(): string {
        return localStorage.getItem('ledgerActiveFilterLocationOn');
    }
    set ledgerActiveFilterLocationOn(value: string) {
        localStorage.setItem('ledgerActiveFilterLocationOn', value);
    }

    get ledgerActiveFilterDateRangeOn(): string {
        return localStorage.getItem('ledgerActiveFilterDateRangeOn');
    }
    set ledgerActiveFilterDateRangeOn(value: string) {
        localStorage.setItem('ledgerActiveFilterDateRangeOn', value);
    }

    get ledgerActiveFilterCodeOn(): string {
        return localStorage.getItem('ledgerActiveFilterCodeOn');
    }
    set ledgerActiveFilterCodeOn(value: string) {
        localStorage.setItem('ledgerActiveFilterCodeOn', value);
    }

    get ledgerActiveFilterToothOn(): string {
        return localStorage.getItem('ledgerActiveFilterToothOn');
    }
    set ledgerActiveFilterToothOn(value: string) {
        localStorage.setItem('ledgerActiveFilterToothOn', value);
    }

    get ledgerActiveFilterDoctorId(): string {
        return localStorage.getItem('ledgerActiveFilterDoctorId');
    }
    set ledgerActiveFilterDoctorId(value: string) {
        localStorage.setItem('ledgerActiveFilterDoctorId', value);
    }

    get ledgerActiveFilterLocationId(): string {
        return localStorage.getItem('ledgerActiveFilterLocationId');
    }
    set ledgerActiveFilterLocationId(value: string) {
        localStorage.setItem('ledgerActiveFilterLocationId', value);
    }

    get ledgerActiveFilterDateRangeStart(): string {
        return localStorage.getItem('ledgerActiveFilterDateRangeStart');
    }
    set ledgerActiveFilterDateRangeStart(value: string) {
        localStorage.setItem('ledgerActiveFilterDateRangeStart', value);
    }

    get ledgerActiveFilterDateRangeEnd(): string {
        return localStorage.getItem('ledgerActiveFilterDateRangeEnd');
    }
    set ledgerActiveFilterDateRangeEnd(value: string) {
        localStorage.setItem('ledgerActiveFilterDateRangeEnd', value);
    }

    get ledgerActiveFilterCodes(): string[] {
        if (localStorage.getItem('ledgerActiveFilterCodes')) {
            return JSON.parse(localStorage.getItem('ledgerActiveFilterCodes')) as string[];
        } else {
            return [];
        }
    }
    set ledgerActiveFilterCodes(value: string[]) {
        localStorage.setItem('ledgerActiveFilterCodes', JSON.stringify(value));
    }

    get ledgerActiveFilterTeeth(): string[] {
        if (localStorage.getItem('ledgerActiveFilterTeeth')) {
            return JSON.parse(localStorage.getItem('ledgerActiveFilterTeeth')) as string[];
        } else {
            return [];
        }
    }
    set ledgerActiveFilterTeeth(value: any[]) {
        localStorage.setItem('ledgerActiveFilterTeeth', JSON.stringify(value));
    }

    // --ledger table layout and filters

    get currentClaimManagementMode(): string {
        return localStorage.getItem('currentClaimManagementMode');
    }

    set currentClaimManagementMode(value: string) {
        localStorage.setItem('currentClaimManagementMode', value);
    }

    // Other
    /// /////////////////////////////////////////////////////////////
    get currentMtiExamId(): string {
        return localStorage.getItem('currentMtiExamId');
    }

    set currentMtiExamId(value: string) {
        localStorage.setItem('currentMtiExamId', value);
    }

    get ReferralAppointmentRequest(): IReferralAppointment {
        if (localStorage.getItem('ReferralAppointmentRequest')) {
            return JSON.parse(localStorage.getItem('ReferralAppointmentRequest'));
        } else {
            return null;
        }
    }
    set ReferralAppointmentRequest(value: IReferralAppointment) {
        localStorage.setItem('ReferralAppointmentRequest', JSON.stringify(value));
    }

    get RescheduleAppointmentRequest(): IRescheduleAppointment {
        if (localStorage.getItem('RescheduleAppointmentRequest')) {
            return JSON.parse(localStorage.getItem('RescheduleAppointmentRequest'));
        } else {
            return null;
        }
    }
    set RescheduleAppointmentRequest(value: IRescheduleAppointment) {
        localStorage.setItem('RescheduleAppointmentRequest', JSON.stringify(value));
    }

    get currentTreatmentPlanID(): string {
        return localStorage.getItem('currentTreatmentPlanID');
    }

    set currentTreatmentPlanID(value: string) {
        localStorage.setItem('currentTreatmentPlanID', value);
    }

    get isSelectedMTI(): string {
        return localStorage.getItem('isSelectedMTI');
    }

    set isSelectedMTI(value: string) {
        localStorage.setItem('isSelectedMTI', value);
    }

    get SelectedCaseDescription(): string {
        return localStorage.getItem('SelectedCaseDescription');
    }

    set SelectedCaseDescription(value: string) {
        localStorage.setItem('SelectedCaseDescription', value);
    }

    get isShowModuleSpecificNotes(): string {
        return localStorage.getItem('isShowModuleSpecificNotes');
    }

    set isShowModuleSpecificNotes(value: string) {
        localStorage.setItem('isShowModuleSpecificNotes', value);
    }

    get currentNoteSize(): string {
        return localStorage.getItem('currentNoteSize');
    }

    set currentNoteSize(value: string) {
        localStorage.setItem('currentNoteSize', value);
    }

    get isTreatmentEwlAwlFilter(): string {
        return localStorage.getItem('isTreatmentEwlAwlFilter');
    }

    set isTreatmentEwlAwlFilter(value: string) {
        localStorage.setItem('isTreatmentEwlAwlFilter', value);
    }



    /// ////////////////////////////////////////////////////
    //  calendar V2

    set calendarV2SelectedLocations(value: any[]) {
        localStorage.setItem('CalendarV2SelectedLocations', JSON.stringify(value));
    }
    get calendarV2SelectedLocations(): any[] {
        if (localStorage.getItem('CalendarV2SelectedLocations'))
          {return JSON.parse(localStorage.getItem('CalendarV2SelectedLocations')); }
        else
          {return null; }
    }

    set calendarV2SelectedOperatories (value: any[]) {
      localStorage.setItem('CalendarV2SelectedOperatories', JSON.stringify(value));
    }
    get calendarV2SelectedOperatories(): any[] {
      if (localStorage.getItem('CalendarV2SelectedOperatories'))
      {return JSON.parse(localStorage.getItem('CalendarV2SelectedOperatories')); }
      else
      {return null; }
    }



  load() {
        Globals.annotationsDefaults = new AnnotationDefaults();
        Globals.annotationsDefaults.strokeColor = '#f05b41';
        Globals.annotationsDefaults.fillColor = '#f05b41';
        Globals.annotationsDefaults.strokeWidth = 2;
        Globals.annotationsDefaults.fontSize = 12;
        Globals.annotationsDefaults.font = '0';
        Globals.annotationsDefaults.fontName = 'Arial';
        Globals.annotationsDefaults.lineStartCap = 0;
        Globals.annotationsDefaults.lineEndCap = 0;
        Globals.annotationsDefaults.fontStyle = 0;

        this.LOCID = localStorage.getItem('LOCID');
        this.LOCenumCountryId = localStorage.getItem('LOCenumCountryId');

        let oldGlobal: any = localStorage.getItem('global');
        if (oldGlobal) {
            oldGlobal = JSON.parse(oldGlobal);
            this.tdo12patientNO = oldGlobal.tdo12PatientNo;
            this.currentPatientId = oldGlobal.currentPatientId;  // patientid
            this.currentPatientFullName = oldGlobal.currentPatientFullName;
            this.ThePatient = oldGlobal.ThePatient;
            this.currentAppointmentId = oldGlobal.currentAppointmentId;
            this.currentPatientSelectedCaseItem = oldGlobal.currentPatientSelectedCaseItem;
            this.currentPatientCaseId = oldGlobal.currentPatientCaseId;

            this.LOCID = localStorage.getItem('LOCID');
            this.LOCenumCountryId = localStorage.getItem('LOCenumCountryId');
            this.TDOCID = localStorage.getItem('TDOCID');

            this.currentPatientCaseWorkItem = oldGlobal.currentPatientCaseWorkItem;
            this.currentPatientCaseWorkItemID = oldGlobal.currentPatientCaseWorkItemID;
            this.currentPatientCaseWorkItemEventID = oldGlobal.currentPatientCaseWorkItemEventID;
            this.currentPatientCaseWorkItemFormsID = oldGlobal.currentPatientCaseWorkItemFormsID;


            this.currentProviderDoctorID = oldGlobal.currentProviderDoctorID;
            this.currentProviderDoctorContactID = oldGlobal.currentProviderDoctorContactID;
            this.currentProviderDoctorFullName = oldGlobal.currentProviderDoctorFullName;

            this.currentLedgerTableLayout = oldGlobal.currentLedgerTableLayout;
            this.currentClaimManagementMode = oldGlobal.currentClaimManagementMode;
            this.currentMtiExamId = oldGlobal.currentMtiExamId;

        }

        if (!this.currentPatientSelectedCaseItem) {
            this.currentPatientSelectedCaseItem = null;
        }

        if (!this.currentLedgerTableLayout) {
            this.currentLedgerTableLayout = [];
        }

    /* if (!this.currentPatientCaseWorkItem) {
      this.currentPatientCaseWorkItem = {};
    }*/
    }

    // TODO: This shouldn't be required as we should be saving in setters
    save() {
        const tmpGlobal: any = {};
        tmpGlobal.tdo12PatientNo = this.tdo12patientNO;
        tmpGlobal.currentPatientId = this.currentPatientId; // patientid
        tmpGlobal.currentPatientFullName = this.currentPatientFullName;
        tmpGlobal.ThePatient = this.ThePatient;
        tmpGlobal.currentAppointmentId = this.currentAppointmentId;
        tmpGlobal.currentPatientSelectedCaseItem = this.currentPatientSelectedCaseItem ? this.currentPatientSelectedCaseItem : null;
        tmpGlobal.currentPatientCaseId = this.currentPatientCaseId;
        tmpGlobal.currentPatientCaseWorkItem = this.currentPatientCaseWorkItem;
        tmpGlobal.currentPatientCaseWorkItemID = this.currentPatientCaseWorkItemID;
        tmpGlobal.currentPatientCaseWorkItemEventID = this.currentPatientCaseWorkItemEventID;
        tmpGlobal.currentPatientCaseWorkItemFormsID = this.currentPatientCaseWorkItemFormsID;
        tmpGlobal.currentProviderDoctorID = this.currentProviderDoctorID;
        tmpGlobal.currentProviderDoctorContactID = this.currentProviderDoctorContactID;
        tmpGlobal.currentProviderDoctorFullName = this.currentProviderDoctorFullName;
        tmpGlobal.currentClaimManagementMode = this.currentClaimManagementMode;
        tmpGlobal.WorkStationName = this.WorkStationName;
        tmpGlobal.WorkStationID = this.WorkStationID;
        tmpGlobal.currentMtiExamId = this.currentMtiExamId;
        tmpGlobal.currentLedgerTableLayout = this.currentLedgerTableLayout ? this.currentLedgerTableLayout : [];
        tmpGlobal.LOCenumCountryId = this.LOCenumCountryId;
        localStorage.setItem('global', JSON.stringify(tmpGlobal));
    }

    clear() {
        if (this.intervalTimer) {
            clearTimeout(this.intervalTimer);
            this.intervalTimer = false;
        }
        localStorage.removeItem('global');
    }

}

declare global {
    interface Array<T> {
        applyMultipleFilters(filterFunctions: any[]): Array<T>;
    }
}

if (!Array.prototype.applyMultipleFilters) {
    Array.prototype.applyMultipleFilters = function <T>(this: T[], filterFunctions: any[]): T[] {
        let array: T[] = this;
        filterFunctions.forEach(filterFunction => {
            array = array.filter(filterFunction);
        });
        return array;
    };
}
